import delivery from "../../images/projects/delivery.png";
import stopwatch from "../../images/projects/cronometro.png";
import drawer from "../../images/projects/sorteio.png";
import converter from "../../images/projects/conversor-moeda.png";
import gamemario from "../../images/projects/mario-game.png";
import wecare from "../../images/projects/we-care.png";
import devlinks from "../../images/projects/dev-links.png";
import numbersecret from "../../images/projects/number-secret.png";
import marioproject from "../../images/projects/mario-project.png";
import spotify from "../../images/projects/spotify.png";
import nlwconnect from "../../images/projects/nlw-connect.png";
import botequim from "../../images/projects/botequim.png";
import fswdonalds from "../../images/projects/fsw-donalds.png";
import projetoarray from "../../images/projects/projeto-array.png";
import cadastrousuario from "../../images/projects/cadastro-usuario.png";
import cronometro from "../../images/projects/cronometro1.png";
import jokenpo from "../../images/projects/jokenpo.png";
import calculadora from "../../images/projects/calculadora.png";
import jogodavelha from "../../images/projects/jogo-da-velha.png";
import tetris from "../../images/projects/tetris.png";
import dragonball from "../../images/projects/dragonball.png";
import compras from "../../images/projects/compras.png";
import oficina from "../../images/projects/oficina.png";
import simbar from "../../images/projects/simbar.png";
import snakegame from "../../images/projects/snake-game.png";
import tarefasreact from "../../images/projects/tarefas-react.png";
import movies from "../../images/projects/movies.png";
import lojinha from "../../images/projects/lojinha.png";
import listacontatos from "../../images/projects/lista-contatos.png";
import tarefas from "../../images/projects/tarefas.png";
import controleleite from "../../images/projects/controle-leite.png";
import qrcode from "../../images/projects/qrcode.png";
import campominado from "../../images/projects/campo-minado.png";
import pacman from "../../images/projects/pacman.png";
import chatbot from "../../images/projects/chatbot.png";
import dtmoney from "../../images/projects/dtmoney.png";
import ignite from "../../images/projects/ignite.png";
import chatreal from "../../images/projects/chatreal.png";
import applewatch from "../../images/projects/applewatch.png";
import audiobook from "../../images/projects/audiobook.png";
import babycontrol from "../../images/projects/babycontrol.png";
import primegestor from "../../images/projects/primegestor.png";

export const projects = [
  {
    id: 1,
    title: "Delivery Ki Delícia",
    img: delivery,
    lang: "JavaScript",
    desc: "Um aplicativo de delivery moderno e responsivo, que permite navegar por categorias, visualizar produtos e fazer pedidos de forma prática.",
    repoLink: "https://github.com/Hugobertoncelo/Delivery",
    siteLink: "https://hugobertoncelo.github.io/Delivery/",
  },
  {
    id: 2,
    title: "Relógio Digital",
    img: stopwatch,
    lang: "HTML e CSS",
    desc: "Um relógio digital funcional e preciso, com design minimalista e interface intuitiva.",
    repoLink: "https://github.com/Hugobertoncelo/Relogio-Digital",
    siteLink: "https://hugobertoncelo.github.io/Relogio-Digital/",
  },
  {
    id: 3,
    title: "Sorteador",
    img: drawer,
    lang: "HTML e CSS",
    desc: "Um aplicativo simples que gera números aleatórios com um design leve e intuitivo.",
    repoLink: "https://github.com/Hugobertoncelo/Dev-Sorteio",
    siteLink: "https://hugobertoncelo.github.io/Dev-Sorteio/",
  },
  {
    id: 4,
    title: "Conversor de moedas",
    img: converter,
    lang: "JavaScript",
    desc: "Aplicação desenvolvida para facilitar a conversão entre diferentes moedas em tempo real, com interface intuitiva e responsiva.",
    repoLink: "https://github.com/Hugobertoncelo/Conversor-de-moedas",
    siteLink: "https://hugobertoncelo.github.io/Conversor-de-moedas/",
  },
  {
    id: 5,
    title: "Mario Game",
    img: gamemario,
    lang: "Jogos",
    desc: "Jogo simples do Mario onde é possível pular obstáculos. O jogo termina quando você colide com algum obstáculo.",
    repoLink: "https://github.com/Hugobertoncelo/Mario-Game",
    siteLink: "https://hugobertoncelo.github.io/Mario-Game/",
  },
  {
    id: 6,
    title: "We care",
    img: wecare,
    lang: "HTML e CSS",
    desc: "Projeto simples realizado em HTML e CSS.",
    repoLink: "https://github.com/Hugobertoncelo/we-care",
    siteLink: "https://hugobertoncelo.github.io/we-care/",
  },
  {
    id: 7,
    title: "DevLinks",
    img: devlinks,
    lang: "HTML e CSS",
    desc: "O DevLinks é um agregador de links para usar como cartão de visitas online.",
    repoLink: "https://github.com/Hugobertoncelo/Projeto",
    siteLink: "https://hugobertoncelo.github.io/Projeto/",
  },
  {
    id: 8,
    title: "Número Secreto",
    img: numbersecret,
    lang: "HTML e CSS",
    desc: "Projeto desenvolvido na Trilha Explorer da Rocketseat, onde o objetivo é adivinhar um número secreto.",
    repoLink: "https://github.com/Hugobertoncelo/logica-js-projeto_inicial",
    siteLink: "https://hugobertoncelo.github.io/logica-js-projeto_inicial/",
  },
  {
    id: 9,
    title: "Mario Bros",
    img: marioproject,
    lang: "HTML e CSS",
    desc: "Projeto construído na DevClub, exibindo a página inicial do Mario Bros.",
    repoLink: "https://github.com/Hugobertoncelo/mario",
    siteLink: "https://hugobertoncelo.github.io/mario/",
  },
  {
    id: 10,
    title: "Projeto Spotify",
    img: spotify,
    lang: "JavaScript",
    desc: "Clone funcional do Spotify utilizando React, Node.js e MongoDB, explorando rotas, gerenciamento de estado e APIs.",
    repoLink: "https://github.com/Hugobertoncelo/Spotify",
    siteLink: "https://spotify-df33.onrender.com/",
  },
  {
    id: 11,
    title: "NLW Connect",
    img: nlwconnect,
    lang: "JavaScript",
    desc: "Projeto desenvolvido durante o NLW Connect da Rocketseat, com HTML, CSS e JavaScript.",
    repoLink: "https://github.com/Hugobertoncelo/nlw-connect",
    siteLink: "https://hugobertoncelo.github.io/nlw-connect/",
  },
  {
    id: 12,
    title: "Cardápio Botequim",
    img: botequim,
    lang: "JavaScript",
    desc: "Cardápio responsivo, intuitivo e acessível, desenvolvido com HTML, CSS e JavaScript, com QR Code funcional.",
    repoLink: "https://github.com/Hugobertoncelo/Botequim",
    siteLink: "https://hugobertoncelo.github.io/Botequim/",
  },
  {
    id: 13,
    title: "FSW Donalds",
    img: fswdonalds,
    lang: "TypeScript",
    desc: "Réplica da página inicial do McDonald's criada com React e TypeScript durante a Fullstack Week.",
    repoLink: "https://github.com/Hugobertoncelo/Fullstackweek-donalds",
    siteLink: "https://fullstackweek-donalds-ten.vercel.app/fsw-donalds",
  },
  {
    id: 14,
    title: "Projeto Array",
    img: projetoarray,
    lang: "JavaScript",
    desc: "Projeto prático aplicando conceitos de manipulação de arrays com forEach, map, reduce e filter.",
    repoLink: "https://github.com/Hugobertoncelo/Projeto-Array",
    siteLink: "https://hugobertoncelo.github.io/Projeto-Array/",
  },
  {
    id: 15,
    title: "Cadastro de Usuários",
    img: cadastrousuario,
    lang: "JavaScript",
    desc: "Aplicação que permite criar, visualizar e deletar usuários com interface simples e interativa.",
    repoLink: "https://github.com/Hugobertoncelo/cadastro-usuario",
    siteLink: "https://cadastro-usuario-kappa.vercel.app/",
  },
  {
    id: 16,
    title: "Cronômetro",
    img: cronometro,
    lang: "HTML e CSS",
    desc: "Cronômetro desenvolvido com HTML, CSS e JavaScript, ideal para praticar lógica e design.",
    repoLink: "https://github.com/Hugobertoncelo/Contador",
    siteLink: "https://hugobertoncelo.github.io/Contador/",
  },
  {
    id: 17,
    title: "Jokenpô",
    img: jokenpo,
    lang: "Jogos",
    desc: "Clássico Jokenpô recriado com HTML, CSS e JavaScript. Desafie a máquina!",
    repoLink: "https://github.com/Hugobertoncelo/Jokenpo",
    siteLink: "https://hugobertoncelo.github.io/Jokenpo/",
  },
  {
    id: 18,
    title: "Calculadora",
    img: calculadora,
    lang: "HTML e CSS",
    desc: "Calculadora simples que demonstra os conceitos básicos de front-end e lógica de programação.",
    repoLink: "https://github.com/Hugobertoncelo/Calculadora",
    siteLink: "https://hugobertoncelo.github.io/Calculadora/",
  },
  {
    id: 19,
    title: "Jogo da Velha",
    img: jogodavelha,
    lang: "Jogos",
    desc: "Jogo da Velha criado com HTML, CSS e JavaScript, com design responsivo e jogabilidade fluida.",
    repoLink: "https://github.com/Hugobertoncelo/Jogo-da-Velha",
    siteLink: "https://hugobertoncelo.github.io/Jogo-da-Velha/",
  },
  {
    id: 20,
    title: "Tetris",
    img: tetris,
    lang: "Jogos",
    desc: "Tetris recriado com HTML, CSS e JavaScript, com jogabilidade clássica e controles intuitivos.",
    repoLink: "https://github.com/Hugobertoncelo/Tetris",
    siteLink: "https://hugobertoncelo.github.io/Tetris/",
  },
  {
    id: 21,
    title: "Projeto DragonBall",
    img: dragonball,
    lang: "JavaScript",
    desc: "Página dedicada ao universo de Dragon Ball, com personagens e momentos marcantes da saga.",
    repoLink: "https://github.com/Hugobertoncelo/Projeto-DBZ",
    siteLink: "https://hugobertoncelo.github.io/Projeto-DBZ/",
  },
  {
    id: 22,
    title: "Lista de Compras",
    img: compras,
    lang: "JavaScript",
    desc: "Aplicação em React e TypeScript para gerenciar listas de compras com facilidade.",
    repoLink: "https://github.com/Hugobertoncelo/Lista-de-Compras",
    siteLink: "https://lista-de-compras-one-murex.vercel.app/",
  },
  {
    id: 23,
    title: "Oficina Mecânica",
    img: oficina,
    lang: "JavaScript",
    desc: "Página web para oficina mecânica com serviços, contatos e formulário de agendamento.",
    repoLink: "https://github.com/Hugobertoncelo/Oficina-Mecanica",
    siteLink: "https://hugobertoncelo.github.io/Oficina-Mecanica/",
  },
  {
    id: 24,
    title: "Cardápio Simbar",
    img: simbar,
    lang: "React",
    desc: "Cardápio digital interativo em React, acessível por QR Code e otimizado para dispositivos móveis.",
    repoLink: "https://github.com/Hugobertoncelo/Cardapio-Simbar",
    siteLink: "https://cardapio-simbar.vercel.app/",
  },
  {
    id: 25,
    title: "Snake Game",
    img: snakegame,
    lang: "Jogos",
    desc: "Recriação do clássico Snake Game com HTML, CSS e JavaScript.",
    repoLink: "https://github.com/Hugobertoncelo/Snake-Game",
    siteLink: "https://hugobertoncelo.github.io/Snake-Game/",
  },
  {
    id: 26,
    title: "Gerenciador de Tarefas",
    img: tarefasreact,
    lang: "React",
    desc: "Gerenciador de tarefas intuitivo com salvamento local e interface amigável.",
    repoLink: "https://github.com/Hugobertoncelo/Tarefas-React",
    siteLink: "https://tarefas-react-iota.vercel.app/",
  },
  {
    id: 27,
    title: "Filmes e Séries",
    img: movies,
    lang: "JavaScript",
    desc: "Aplicação em React para explorar catálogo de filmes e séries com filtros e detalhes completos.",
    repoLink: "https://github.com/Hugobertoncelo/Movies",
    siteLink: "https://movies-rho-lyart.vercel.app/",
  },
  {
    id: 28,
    title: "Loja Virtual",
    img: lojinha,
    lang: "Angular",
    desc: "Loja virtual infantil desenvolvida com Angular e TypeScript, com design lúdico e responsivo.",
    repoLink: "https://github.com/Hugobertoncelo/Loja-virtual-angular",
    siteLink: "https://loja-virtual-angular.vercel.app/produtos",
  },
  {
    id: 29,
    title: "Lista de Contatos",
    img: listacontatos,
    lang: "React",
    desc: "Aplicação em React que permite cadastrar, editar, excluir e favoritar contatos.",
    repoLink: "https://github.com/Hugobertoncelo/lista-de-contatos",
    siteLink: "https://lista-de-contatos-kappa-five.vercel.app/",
  },
  {
    id: 30,
    title: "Lista de Tarefas",
    img: tarefas,
    lang: "React",
    desc: "Lista de Tarefas com React, TypeScript, Redux e Styled-components, com filtros e edição.",
    repoLink: "https://github.com/Hugobertoncelo/lista-de-tarefas-react",
    siteLink: "https://lista-de-tarefas-react-six.vercel.app/",
  },
  {
    id: 31,
    title: "Controle de Consumo de Leite Infantil",
    img: controleleite,
    lang: "TypeScript",
    desc: "Aplicação em React para controle do consumo diário de leite infantil.",
    repoLink: "https://github.com/Hugobertoncelo/Control-Milk",
    siteLink: "https://control-milk.vercel.app/",
  },
  {
    id: 32,
    title: "Gerador de QR Code e Encurtador de Link",
    img: qrcode,
    lang: "TypeScript",
    desc: "Transforme URLs longas em links curtos e QR Codes prontos para compartilhar.",
    repoLink: "https://github.com/Hugobertoncelo/QRcode-Generator",
    siteLink: "https://qrcodeandlink.netlify.app/",
  },
  {
    id: 33,
    title: "Campo Minado",
    img: campominado,
    lang: "Jogos",
    desc: "Versão moderna do Campo Minado com HTML, CSS e JavaScript puro.",
    repoLink: "https://github.com/Hugobertoncelo/Campo-Minado",
    siteLink: "https://hugobertoncelo.github.io/Campo-Minado/",
  },
  {
    id: 34,
    title: "Pacman",
    img: pacman,
    lang: "Jogos",
    desc: "Recriação do clássico Pac-Man em React, com pontuação e animações.",
    repoLink: "https://github.com/Hugobertoncelo/Pacman",
    siteLink: "https://pacman-one-pied.vercel.app/",
  },
  {
    id: 35,
    title: "ChatBot IA",
    img: chatbot,
    lang: "TypeScript",
    desc: "Durante o evento da Hashtag Treinamentos, desenvolvi um chatbot inteligente utilizando TypeScript e integração com Inteligência Artificial.",
    repoLink: "https://github.com/Hugobertoncelo/ChatBot",
    siteLink: "https://chat-bot-navy-one.vercel.app/",
  },
  {
    id: 36,
    title: "Dt Money",
    img: dtmoney,
    lang: "TypeScript",
    desc: "Mais um passo importante no Ignite da Rocketseat! Desenvolvi o DT Money utilizando TypeScript, React e conceitos avançados como contexto, reducers e consumo de API.",
    repoLink: "https://github.com/Hugobertoncelo/03-dt-money",
    siteLink: "https://03-dt-money-fawn.vercel.app/",
  },
  {
    id: 37,
    title: "Ignite Timer",
    img: ignite,
    lang: "TypeScript",
    desc: "Projeto concluído no Ignite da Rocketseat, agora utilizando TypeScript, React e boas práticas que elevaram meu nível no desenvolvimento front-end.",
    repoLink: "https://github.com/Hugobertoncelo/02-ignite-timer",
    siteLink: "https://02-ignite-timer-livid.vercel.app/",
  },
  {
    id: 38,
    title: "Chat em Tempo Real",
    img: chatreal,
    lang: "TypeScript",
    desc: "Este projeto é um sistema completo de chat em tempo real, desenvolvido em arquitetura monorepo, integrando front-end, back-end e bibliotecas compartilhadas em um único repositório, com foco em experiência do usuário e organização de código.",
    repoLink: "https://github.com/Hugobertoncelo/Projetofullstack",
    siteLink: "https://chat-frontend-2a0i.onrender.com/",
  },
  {
    id: 39,
    title: "Réplica do site Apple",
    img: applewatch,
    lang: "HTML e CSS",
    desc: "Réplica do site de pulseiras Apple desenvolvida com HTML, CSS e JavaScript, com foco em fidelidade visual, responsividade e uma experiência de usuário fluida.",
    repoLink: "https://github.com/Hugobertoncelo/AppleWatch",
    siteLink: "https://hugobertoncelo.github.io/AppleWatch/",
  },
  {
    id: 40,
    title: "Audiobook Dom Casmurro",
    img: audiobook,
    lang: "HTML e CSS",
    desc: "Aplicação web construída com HTML, CSS e JavaScript, incluindo player de áudio, controle de capítulos e layout responsivo para consumir literatura de forma moderna.",
    repoLink: "https://github.com/Hugobertoncelo/Audiobook",
    siteLink: "https://hugobertoncelo.github.io/Audiobook/",
  },
  {
    id: 41,
    title: "Baby Control",
    img: babycontrol,
    lang: "TypeScript",
    desc: "Aplicação de controle de bebê construída com TypeScript, priorizando tipagem forte, organização de estados e escalabilidade. Inclui funcionalidades como registro de mamadas, trocas de fraldas, medicamentos e acompanhamento de rotinas.",
    repoLink: "https://github.com/Hugobertoncelo/Baby-control",
    siteLink: "https://baby-control.netlify.app/",
  },
  {
    id: 42,
    title: "Prime Gestor",
    img: primegestor,
    lang: "TypeScript",
    desc: "Sistema de Controle de Estoque e Vendas desenvolvido em TypeScript, focado em desempenho, organização e escalabilidade. Gerenciamento de produtos, entradas, saídas, vendas e relatórios, com arquitetura pronta para produção.",
    repoLink: "https://github.com/Hugobertoncelo/Stock-Control",
    siteLink: "https://stock-control-one.vercel.app/",
  },
];
